import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SignalButton } from '@vallift/ngl';
import type { DataLibraryVariableUsageItemResponse } from '@core/api/workspace/models/dataLibraryVariableUsageItemResponse';

export interface VariableUsageOverlayData {
  variableName: string;
  usages: DataLibraryVariableUsageItemResponse[];
}

@Component({
  selector: 'app-variable-usage-overlay',
  imports: [SignalButton],
  templateUrl: './variable-usage-overlay.html',
  styleUrl: './variable-usage-overlay.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VariableUsageOverlayComponent {
  private readonly dialogRef = inject(DialogRef<void>);
  private readonly data = inject<VariableUsageOverlayData>(DIALOG_DATA);

  readonly variableName = this.data.variableName;
  readonly usages = this.data.usages;
  readonly title = `Usage of “${this.data.variableName}”`;

  usageLabel(usage: DataLibraryVariableUsageItemResponse): string {
    const formName = usage.display?.formName?.trim() || 'Untitled form';
    const fieldLabel = usage.display?.fieldLabel?.trim();
    const propertyLabel =
      usage.display?.propertyLabel?.trim() || usage.location.property;
    if (fieldLabel) {
      return `${formName} · ${fieldLabel} (${propertyLabel})`;
    }
    return `${formName} · ${usage.targetPath}`;
  }

  close(): void {
    this.dialogRef.close();
  }
}
